module.exports = __webpack_public_path__ + "img/luthi-1.4524beaf.jpg";